import { isDisposable, tryToMarkDispose } from '@tencent/dispose-tree';
import { LOADER_BASE_ORPHAN_INSTANTIATION, LOADER_BASE_STATIC_INSTANTIATION } from '../constants/error-messages';
import { IInstantiationHookPoint } from './instantiation';
import { InstantiationHook } from './instantiation-hook';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function paramsToArray(params) {
    if (Array.isArray(params)) {
        return params;
    }
    return [params];
}
/**
 * 异步loader的通用逻辑，包括解析Ioc容器设置、初始化实例、销毁实例
 */
export class LoaderBase {
    constructor(instantiationService) {
        this.instantiationHook = new InstantiationHook();
        this.selfInstantiationService = instantiationService;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    createInstance(ctor, allParams) {
        if (this.instance) {
            return this.instance;
        }
        const innerInstantionService = this.loaderInstantiationService();
        const instance = innerInstantionService.createInstance(ctor, 
        // eslint-disable-next-line  @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ...allParams);
        this.executeHooks(instance, IInstantiationHookPoint.POST_CONSTRUCTOR);
        this.instance = instance;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        tryToMarkDispose(instance);
        return instance;
    }
    /**
       * 根据一定的优先级获取当前loader的InstantiationService
       */
    loaderInstantiationService() {
        // 优先使用继承者提供的Ioc容器，其次使用静态容器
        const manuallInstantion = this.getInstantion() || LoaderBase.staticInstantiationService;
        // 校验设置的Ioc容器是否合法
        if (manuallInstantion && manuallInstantion !== this.selfInstantiationService) {
            // 检查是否为孤儿节点
            let orphanInstantiationService = true;
            manuallInstantion.getHierarchyNode().walkUp((instantiationNode) => {
                // 可达性验证
                if (orphanInstantiationService && instantiationNode === this.selfInstantiationService) {
                    orphanInstantiationService = false;
                }
            });
            // Ioc容器为孤儿节点抛出异常
            if (orphanInstantiationService) {
                throw new Error(LOADER_BASE_ORPHAN_INSTANTIATION);
            }
        }
        const instantionService = manuallInstantion || this.selfInstantiationService;
        return instantionService;
    }
    /**
     * 可由继承者提供默认的InstantiationService
     */
    getInstantion() {
        return null;
    }
    addHook(hookPoint, callback) {
        this.instantiationHook.addHook(hookPoint, callback);
    }
    executeHooks(instance, point) {
        this.instantiationHook.executeHooks(instance, point);
    }
    /**
     * 可静态的设置InstantiationService
     */
    static initStaticInstantiationService(instantiation) {
        if (!LoaderBase.staticInstantiationService) {
            LoaderBase.staticInstantiationService = instantiation;
        }
        else {
            throw new Error(LOADER_BASE_STATIC_INSTANTIATION);
        }
    }
    dispose(trace) {
        var _a, _b;
        if (!this.instance) {
            return;
        }
        // 如果loader加载的实例需要清理，则调用它的dipose方法
        if (isDisposable(this.instance)) {
            trace && trace.branch(`${((_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name) || ''}instance`);
            this.instance.dispose(trace);
        }
        this.instance = null;
    }
}
//# sourceMappingURL=loader-base.js.map